import React from "react";
import "./AssessmentCriteriaOriginal.css";
import { AssessmentCriteriaInputValues } from "../../constants/Constants";

const RadioGroup = ({ name, value, onChange, yesId, noId, naId, mode }) => (
  <div
    className="field is-grouped is-grouped-multiline"
    role="radiogroup"
    aria-labelledby={`${name}-legend`}
  >
    <div className="control">
      <label className="radio">
        <input
          type="radio"
          name={name}
          id={yesId}
          value="yes"
          checked={value === "yes"}
          onChange={onChange}
          disabled={mode === "view"}
        />{" "}
        Yes
      </label>
    </div>
    <div className="control">
      <label className="radio">
        <input
          type="radio"
          name={name}
          id={noId}
          value="no"
          checked={value === "no"}
          onChange={onChange}
          disabled={mode === "view"}
        />{" "}
        No
      </label>
    </div>
    <div className="control">
      <label className="radio">
        <input
          type="radio"
          name={name}
          id={naId}
          value="not_attempted"
          checked={value === "not_attempted"}
          onChange={onChange}
          disabled={mode === "view"}
        />{" "}
        Not attempted
      </label>
    </div>
  </div>
);

const getDisplayForAchieved = (val) => {
  if (val === AssessmentCriteriaInputValues.YES) return "Yes";
  if (val === AssessmentCriteriaInputValues.NO) return "No";
  if (val === AssessmentCriteriaInputValues.NOT_ATTEMPTED)
    return "Not attempted";
  return "";
};

const AssessmentCriteriaOriginalTable = ({
  criteriaDetails,
  values,
  notes,
  candidateId,
  onChangeValue,
  onChangeNote,
  onCriteriaAchievedChange,
  mode = "edit",
  tableId = "tblCandidateMarksEntry",
  className = "",
  disableOriginalMarks = false,
}) => {
  const safeValues = values || {};
  const safeNotes = notes?.[candidateId] || {};

  const handleRadioChange = (criteriaName, value) => {
    onChangeValue(candidateId, criteriaName, value);

    const updatedValues = {
      ...safeValues,
      [criteriaName]: value,
    };

    const yesCount = Object.values(updatedValues).filter(
      (v) => v === "yes",
    ).length;

    onCriteriaAchievedChange(candidateId, yesCount);
  };

  return (
    <div className="tabcard">
      <div className="table-scroll-x">
        <table
          id={tableId}
          className={`table is-hoverable is-fullwidth is-vcentered ${className}`}
        >
          <thead>
            <tr>
              <th>Assessment criteria</th>
              <th>Description</th>
              <th>Has the candidate achieved the assessment criteria?</th>
              <th>Evidence location / notes (optional)</th>
            </tr>
          </thead>
          <tbody>
            {criteriaDetails.map((row, idx) => {
              const criteriaName = row.assessmentCriteriaName;
              const currentValue = safeValues[criteriaName] ?? "not_attempted";
              const noteValue = safeNotes[criteriaName] || "";

              const yesId = `acmark_${candidateId}_${idx + 1}`;
              const noId = `${yesId}_no`;
              const naId = `${yesId}_na`;

              return (
                <tr key={`${candidateId}-${criteriaName}`}>
                  <td>{criteriaName}</td>
                  <td>{row.assessmentCriteriaDescription}</td>
                  <td>
                    {mode === "view" || disableOriginalMarks ? (
                      <span>{getDisplayForAchieved(currentValue)}</span>
                    ) : (
                      <RadioGroup
                        name={`${candidateId}-${criteriaName}`}
                        value={currentValue}
                        yesId={yesId}
                        noId={noId}
                        naId={naId}
                        onChange={(e) =>
                          handleRadioChange(criteriaName, e.target.value)
                        }
                        mode={mode}
                      />
                    )}
                  </td>
                  <td className="p-0">
                    <div
                      className="textarea-wrapper"
                      style={{ position: "relative" }}
                    >
                      <textarea
                        className="textarea"
                        rows={2}
                        maxLength={250}
                        value={noteValue}
                        disabled={mode === "view" || disableOriginalMarks}
                        onChange={(e) =>
                          onChangeNote(
                            candidateId,
                            criteriaName,
                            e.target.value,
                          )
                        }
                        aria-label={`${criteriaName} evidence location / notes`}
                      />
                      {mode !== "view" && !disableOriginalMarks && (
                        <span
                          className="char-counter"
                          style={{
                            position: "absolute",
                            bottom: "4px",
                            right: "8px",
                            fontSize: "12px",
                            color: "#666",
                          }}
                        >
                          {noteValue.length}/250
                        </span>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AssessmentCriteriaOriginalTable;
